export default interface Printer {
    id: number;
    name: string;
}

export const printerDefaultProps: Printer = {
    id: 0,
    name: '',
}